<script>
export default {
  name: "MobileMappingQuote",
  data: () => ({
    headshot: require("@/assets/mobile-mapping-quote-headshot.png")
  })
}
</script>

<template>
<div class="quote-box">
  <img
    :src="headshot"
    width="200px"
    height="200px" />
  <div class="quote-text-box">
    <div class="quote-text">
      Neben eigenen Anwendungsfällen wollen wir unser Angebot gemeinsam mit zukünftigen Partnern praxisnah weiterentwickeln. Wir holen Feedback ein, um Nutzen, Anforderungen und weitere Anwendungsfälle gemeinsam zu schärfen.
    </div>
    <div class="quote-name">Thorsten Jansen</div>
    <div class="quote-company">NEW Netz</div>
  </div>
</div>
</template>

<style scoped>
.quote-box {
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.quote-text-box {
  padding-left: 56px
}

.quote-text {
  font-size: 24px;
  font-family: "GeometriaMedium", sans-serif;
  line-height: 32px;
  padding-bottom: 37px ;
}

.quote-name {
  font-family: "GeometriaMedium", sans-serif;
}

.quote-company {
  font-size: 16px;
}
</style>